/**
 * Route handle key utilities and enums
 */

/**
 * Route handle keys for QuickLoan flow
 * Used in router.tsx handle data and QuickLoanLayout for route-based conditions
 */
export enum RouteHandleKey {
  LOAN_OFFICER = 'loanOfficer',
  LANDING_LOAN_OFFICER = 'landingLoanOfficer',
  LOAN_SETUP = 'loanSetup',
  DISCLOSURE = 'disclosure',
  SIGN_UP = 'signUp',
}

export interface RouteHandle {
  key: RouteHandleKey;
}
